import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "textarea"]

  connect() {
    this.files = []
    this.boundPaste = this.handlePaste.bind(this)
    this.element.addEventListener("paste", this.boundPaste)
    this.element.addEventListener("turbo:submit-end", () => this.clear())
  }

  disconnect() {
    this.element.removeEventListener("paste", this.boundPaste)
  }

  selectFiles() {
    this.inputTarget.click()
  }

  preview() {
    const newFiles = Array.from(this.inputTarget.files)
    this.files = [...this.files, ...newFiles]
    this.renderPreviews()
  }

  handlePaste(event) {
    const items = event.clipboardData?.items
    if (!items) return

    for (const item of items) {
      if (item.type.startsWith("image/")) {
        event.preventDefault()
        const file = item.getAsFile()
        if (file) {
          this.files.push(file)
          this.renderPreviews()
        }
        break
      }
    }
  }

  removeFile(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    this.files.splice(index, 1)
    this.renderPreviews()
  }

  renderPreviews() {
    if (!this.hasPreviewTarget) return

    if (this.files.length === 0) {
      this.previewTarget.classList.add("hidden")
      this.previewTarget.innerHTML = ""
      this.syncFileInput()
      return
    }

    this.previewTarget.classList.remove("hidden")
    this.previewTarget.innerHTML = ""

    this.files.forEach((file, index) => {
      const wrapper = document.createElement("div")
      wrapper.className = "relative inline-block"

      const img = document.createElement("img")
      img.className = "h-16 w-16 object-cover rounded border border-base-300"
      img.src = URL.createObjectURL(file)

      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.className = "absolute -top-1.5 -right-1.5 btn btn-circle btn-xs btn-error"
      removeBtn.dataset.index = index
      removeBtn.dataset.action = "click->chat-upload#removeFile"
      removeBtn.innerHTML = "&times;"

      wrapper.appendChild(img)
      wrapper.appendChild(removeBtn)
      this.previewTarget.appendChild(wrapper)
    })

    this.syncFileInput()
  }

  syncFileInput() {
    const dt = new DataTransfer()
    this.files.forEach(f => dt.items.add(f))
    this.inputTarget.files = dt.files
  }

  clear() {
    this.files = []
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
      this.previewTarget.innerHTML = ""
    }
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
    }
  }
}
